import React from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import { IconArrowLeft } from "@velaro/velaro-component-lib/";
import IconByName from "@/components/ds/IconByName";

export default function BigCommerceOverview() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="font-semibold group flex items-center gap-2 justify-between mb-6">
        <div className="flex items-center gap-2">
          <div className="w-14 h-14 border-slate-300 relative mr-4 rounded border p-2 content-center flex items-center justify-center">
            <img src="/img/bigcommerce.svg" alt="BigCommerce" className="w-10 h-10" />
          </div>
          <div>
            <div className="font-semibold text-slate-gray-800 text-lg">BigCommerce</div>
            <div className="font-normal text-slate-gray-400 text-sm">
              Connect BigCommerce to look up customers, orders, and products from your store during live chats.
            </div>
          </div>
        </div>
        <PrimaryBlueButton
          label="Connect BigCommerce"
          onClick={() => navigate("/integrations/bigcommerce/create")}
          prefixIcon={null}
          className="font-medium"
        />
      </div>

      <div className="flex border-b mb-4">
        <div className="py-2 mr-4 cursor-pointer text-slate-800 text-sm border-b-2 border-b-slate-600 px-3">
          Overview
        </div>
      </div>

      <div className="text-sm text-slate-800 space-y-3">
        <p>
          Connect BigCommerce so your support agents can instantly pull up customer accounts, order history, and product details during live conversations — without leaving Velaro.
        </p>
        <p>
          AI workflow nodes can query your BigCommerce store to look up orders by ID, search customers by email, and retrieve product information automatically during automated flows.
        </p>
        <p>
          When a visitor provides their email, Velaro can match them to their BigCommerce account and surface recent orders, lifetime value, and account status directly in the agent sidebar.
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          { title: "Customer Lookup", desc: "Search BigCommerce customers by email or name during live chats. See account details, order count, and lifetime value.", icon: "User" },
          { title: "Order History", desc: "Pull up order status, tracking info, and recent purchases so agents can resolve support questions instantly.", icon: "Package" },
          { title: "AI Workflow Tools", desc: "Workflow AI nodes can query customers, orders, and products during automated flows — no agent needed.", icon: "Bot" }
        ].map((f) => (
          <div key={f.title} className="rounded-lg border border-slate-200 p-4">
            <div className="mb-2 text-zinc-600"><IconByName name={f.icon} className="w-6 h-6" /></div>
            <div className="font-medium text-slate-800 text-sm mb-1">{f.title}</div>
            <div className="text-xs text-slate-500">{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function BigCommerceBackToIntegrationLanding() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-slate-600" onClick={() => navigate("/integrations")}>
      <IconArrowLeft className="h-6 w-6" />
      Back
    </div>
  );
}

export function BigCommerceBackToOverview() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-slate-600" onClick={() => navigate("/integrations/bigcommerce/overview")}>
      <IconArrowLeft className="h-6 w-6" />
      Back to BigCommerce
    </div>
  );
}
